import { useContext, useEffect, useState } from 'preact/hooks';
import { createDirectus, graphql }         from '@directus/sdk';

import { chunkArray } from '../helpers.js';
import GlobalContext  from '../context/GlobalContext.js';
import { routes }     from '../data/routes.js';
import slugify        from 'slugify';

const useNewWatches2024PageData = (apikey) => {

  const { pathroot, retailer } = useContext(GlobalContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPageData = async () => {
    const client = createDirectus(import.meta.env.VITE_DIRECTUS_API_URL).with(graphql());
    try {
      const result = await client.query(`
     query {
       rlx_retailer(filter: {rlx_api_key: {_eq: "${apikey}"}}) {
           retailer_name
           retailer_location
        }
       rlx_page(filter: {title: {_eq: "rolex-at-retailer"}}) {
        title
        page_assets {
          rlx_responsive_asset_id {
            title
            asset_landscape {
              id
            }
            asset_portrait {
              id
            }
          }
        }
      }
    }
  `)
      setData(result);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }

  const pushElements = {
    showrooms: {
      heading: '',
      elements: [
        {
          image: 'push-landscape-1',
          heading: 'Unsere Rolex Verkaufsräume',
          subtitle: '',
          cta: 'Erfahren Sie mehr',
          link_to: pathroot + routes['rolex-at'].de + '/' + slugify(retailer.retailer_name, { lower: true }) + routes['showrooms'].de
        }
      ]
    },
    teamAndHistory: {
      heading: '',
      elements: [
        {
          image: 'push-s-2',
          heading: 'Unser Team',
          subtitle: '',
          cta: 'Mehr erfahren',
          link_to: pathroot + routes['rolex-at'].de + '/' + slugify(retailer.retailer_name, { lower: true }) + routes['team'].de
        },
        {
          image: 'push-s-3',
          heading: 'Unsere Geschichte',
          subtitle: '',
          cta: 'Mehr erfahren',
          link_to: pathroot + routes['rolex-at'].de + '/' + slugify(retailer.retailer_name, { lower: true }) + routes['history'].de
        }
      ]
    }
  }

  useEffect(() => {
    if (!data) {
      fetchPageData()
    }
    if (data) {
      setIsLoading(false);
    }
  }, [data]);


  return { data, isLoading, error, pushElements };

};

export default useNewWatches2024PageData;
